import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './blank-page.css?inline';

const CName = 'blank-page';

/**
 * Blank page template — renders the routed view and nothing else.
 *
 * No header, footer, sidebar, bottom bar, a11y widget, or page grid. Built for
 * views that own the entire viewport and are not laid out against the host
 * (the Cornucopia cashier: its payment element renders its own header and
 * assumes nothing of ours can appear on top of or beside it).
 *
 * Consequences a consumer takes on, because `base-page` normally provides them:
 * - a back/close affordance — the view must offer its own way out
 * - the document title — the view must set it (`updateMetaTitle`)
 * - page padding / width constraints — the slotted view gets the full viewport
 *
 * @element blank-page
 * @slot - The routed view
 */
@customElement(CName)
export class BlankPage extends LitElement {
  static readonly styles = unsafeCSS(styles);

  firstUpdated(): void {
    // Every page template must release the boot-time 'page-template' render
    // task. Without this, a hard load onto a BLANK route (deep link, reload, a
    // payment-provider return redirect) keeps the splash up until the task's
    // TASK_TIMEOUT fallback clears it.
    window.$app.renderService.removePageTemplateTask();
  }

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: BlankPage;
  }
}
